import { HStack, List, ListItem, Stack, Text } from "@chakra-ui/react";
import { Card, formatDate, Link } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { SummaryBoxes } from "@src/components/modules/invoices/Create/components/Steps/BudgetsSplits/SummaryBoxes";
import { Icon } from "@src/components/ui-kit/Icon";
import { can } from "@src/utils/components/permissions";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { InvoiceTypeEnum, useInvoiceStore } from "../../store";
import s from "./Summary.module.css";

export const Summary = observer(function Summary() {
  const { workspaceStore } = useStore();
  const store = useInvoiceStore();

  return (
    <Card>
      <Stack>
        <Stack px="5" pt="4" pb="3" spacing="3">
          <Text fontWeight="medium">
            <Trans>Summary</Trans>
          </Text>

          <List spacing="2">
            <ListItem>
              <Icon name="building-03" mr="2" w="4" h="4" color="grey.500" />
              {store.isBrandMultiSelect ? (
                <Trans>Brand/s</Trans>
              ) : (
                <Trans>Brand</Trans>
              )}
              {": "}
              {store.selectedBrands.map((i) => i.name).join(", ")}
            </ListItem>

            <ListItem>
              <Icon name="building-03" mr="2" w="4" h="4" color="grey.500" />
              <Trans>Legal entity</Trans>
              :&nbsp;
              {
                workspaceStore.getCompany(store.form.workspace_company_id.$)
                  ?.name
              }
            </ListItem>

            <ListItem>
              <Icon name="grid-01" w="4" h="4" mr="2" color="grey.500" />
              {store.isProjectMultiSelect ? (
                <Trans>Project/s</Trans>
              ) : (
                <Trans>Project</Trans>
              )}
              {": "}
              {store.selectedProjects.map((project) => (
                <span key={project.id} className={s.linkWrap}>
                  <Link
                    href={{
                      pathname: "/projects/detail",
                      query: { id: project.id },
                    }}
                  >
                    {project.code} &mdash; {project.title}
                  </Link>
                </span>
              ))}
            </ListItem>

            {!!store.form.order_ids.$.length && (
              <ListItem>
                <HStack wrap="wrap" spacing="1">
                  <Icon name="hash-02" w="4" h="4" color="grey.500" mr="1" />
                  <Trans>PO/s:</Trans>
                  {store.selectedOrdersOptions.map((i, selectedOrdersIndex) =>
                    i.orders.map((order, index) => (
                      <Link
                        key={order.id}
                        className="text-center"
                        href={{
                          pathname: "/projects/documents",
                          query: { id: i.id, active: "orders" },
                        }}
                      >
                        {order.purchase_order_no}
                        {(selectedOrdersIndex <
                          store.selectedOrdersOptions.length - 1 ||
                          (i.orders.length > 1 &&
                            index < i.orders.length - 1)) &&
                          ", "}
                      </Link>
                    )),
                  )}
                </HStack>
              </ListItem>
            )}

            {store.type !== InvoiceTypeEnum.Proforma && (
              <ListItem>
                <Icon name="calendar" w="4" h="4" color="grey.500" mr="2" />
                {can("requestForInvoicing_accessAccountingAttributes") ? (
                  <Trans>Date of supply</Trans>
                ) : (
                  <Trans>Requested date of invoicing</Trans>
                )}
                : {formatDate(store.form.date_of_supply.$)}
              </ListItem>
            )}
          </List>
        </Stack>

        <SummaryBoxes />
      </Stack>
    </Card>
  );
});
